<div modalHeader class="modal-header py-2">
  <h2 class="my-1"><b>{{title}}</b></h2>
  <!--  <tr-icon [icon]="icon.cancel" classes="close-btn" (click)="cancel()"></tr-icon>-->
</div>

<div modalContent class="modal-body">
  <!-- Form -->
  <form *ngIf="party" role="form" name="addEditForm" #addEditForm="ngForm" novalidate>
    <div *ngIf="showSelectResourceMessage" class="alert alert-warning" role="alert">
      <span>Please select a {{user.resourceSettings?.label || 'resource' }} to track it on the served page.</span>
    </div>
    <div class="row">
      <!-- Phone -->
      <div class="col-xs-12 col-sm-6 form-group">
        <label for="input-modal-phone" class="control-label">Phone<br></label>
        <div class="d-flex">
          <input
            id="input-modal-phone"
            type="tel"
            pattern="[\-+\(\)\s\d]*"
            name="phone"
            class="form-control"
            data-dd-privacy="mask"
            appPhonePatternCountryValidator="phone"
            [phoneCountry]="user?.country"
            #partyPhone="ngModel"
            [(ngModel)]="party.phone"
            [ngClass]="{'is-invalid': partyPhone.touched && partyPhone.invalid }"
            (ngModelChange)="partyPhoneLookup(); changeMessagingProvider();"
            [value]="party.phone | trTel: user.country"
            joyrideStep="AddEditParty"
            [title]="guiderService.getGuidTitle('AddEditParty')"
            [text]="guiderService.getGuidText('AddEditParty')"
            (next)="onNext()"
            (prev)="onPrev()"
            trTrimSpaces
            [class.mr-2]="isWhatsAppEnabled()"
          />
          <tablesready-whatsapp-toggle
            *ngIf="isWhatsAppEnabled()"
            name="messagingProvider"
            [(ngModel)]="party.messagingProvider"
            [disabled]="!party.phone || isUsOrCaPhoneNumber(party.phone) || party.source === partySources.api"
            ngbTooltip="Send via WhatsApp"
          ></tablesready-whatsapp-toggle>
        </div>

        <control-messages [control]="partyPhone"></control-messages>
      </div>
      <!-- Name -->
      <div class="col-xs-12 col-sm-6 form-group">
        <label for="input-modal-name" class="control-label">Name</label>
        <input
          id="input-modal-name"
          type="text"
          #partyName="ngModel"
          [(ngModel)]="party.name"
          name="name"
          data-dd-privacy="mask"
          noWhitespace
          [optional]="true"
          [ngClass]="{'is-invalid': partyName.touched && partyName.invalid }"
          class="form-control"
          [required]="!skipName"
          trTrimSpaces
        />
        <control-messages [control]="partyName"></control-messages>
      </div>
    </div>

    <div class="row" *ngIf="customer">
      <div class="col-12 form-group">
        <tablesready-party-customer-info
          [customer]="customer"
          [timezone]="timezone"
        ></tablesready-party-customer-info>
      </div>
    </div>

    <div class="row" *ngIf="user.waitFields.size">
      <!-- Size -->
      <div class="col-12 form-group">
        <label for="input-modal-size" class="control-label">Size</label>
        <div class="btn-group d-flex flex-wrap"
             id="input-modal-size">

          <common-radio-group
            name="size"
            [items]="sizesRadioItems"
            [(ngModel)]="party.size"
            [indentation]="true"
            (ngModelChange)="selectResources()"
            uncheckedButtonClass="btn-info-outline round btn-tel"
            checkedButtonClass="btn-info-outline round btn-tel"
          ></common-radio-group>

          <input
            name="sizeOther"
            type="number"
            style="width:5rem;"
            placeholder="8+"
            pattern="\d*"
            min="0"
            class="form-control btn-tel"
            #partySizeOther="ngModel"
            [(ngModel)]="sizeOther"
            (change)="changeSize(); selectResources()"
            [min]="0"
            (focus)="party.size>=8"
            [ngClass]="{'is-invalid': partySizeOther.touched && partySizeOther.invalid }"
          />
          <control-messages [control]="partySizeOther"></control-messages>
        </div>
      </div>
    </div>
    <!-- Date -->
    <div class="row" *ngIf="isReservation">
      <div class="col-xs-12 col-sm-6 form-group">
        <label for="reservation-date-input" class="control-label">Date</label>
        <input id="reservation-date-input"
               class="form-control"
               type="text"
               ngbDatepicker
               container="body"
               [minDate]="minDate"
               [maxDate]="maxDate"
               [weekdays]="true"
               [firstDayOfWeek]="7"
               #datepicker="ngbDatepicker"
               name="date"
               [(ngModel)]="party.date"
               (ngModelChange)="changeDate()"
               #partyDate="ngModel"
               [disabled]="selectedTimeMode"
               [ngClass]="{'is-invalid': partyDate.touched && partyDate.invalid}"
               (click)="datepicker.toggle()"
               [restoreFocus]="true"
               autocomplete="off"/>
      </div>
      <!-- Time -->
      <div class="col-xs-12 col-sm-6 form-group">
        <label class="control-label">Time</label>
        <tr-timepicker-input name="time"
                             [(ngModel)]="party.time"
                             (ngModelChange)="changeDate()"
                             [disabled]="selectedTimeMode"
                             #partyTime="ngModel"
                             required>
        </tr-timepicker-input>
      </div>
    </div>
    <!-- quoted -->
    <div class="row">
      <div *ngIf="isWalkin && (!user.waitFields || user.waitFields.quoted_time)"
           class="col-xs-12 col-sm-6 form-group">
        <label for="input-modal-time" class="control-label">{{user.displayOptions?.labels?.quoted || 'quoted time' | titlecase}}</label>
        <div data-toggle="buttons" class="with-five-buttons d-flex justify-content-between">
          <input id="input-modal-time"
                 class="form-control"
                 type="number"
                 [(ngModel)]="party.quoted_time_minutes"
                 name="quoted_time_minutes"
                 required
                 #quotedTime
                 pattern="[-\d]*"
                 [ngClass]="{'is-invalid':quotedTime.touched && quotedTime.invalid }"
                 (blur)="setQuotedTime()"/>
          <button type="button" class="btn btn-info" (click)="changeQuoted(5)" id="plus-5-button">+5</button>
          <button type="button" class="btn btn-info" (click)="changeQuoted(-5)" id="minus-5-button">-5</button>
        </div>
      </div>
      <!-- Notes -->
      <div class="col-xs-12 form-group"
           [ngClass]="(!user.waitFields || user.waitFields.quoted_time) ? 'col-sm-6' : 'col-sm-12'">
        <ng-container *ngIf="(user?.noteOptions || []).length > 0; else plainNoteInput">
          <frontend-dropdown-clear [dropdown]="notesDropdown">
            <label for="input-modal-note" class="control-label">Notes</label>
          </frontend-dropdown-clear>
          <frontend-dropdown
            #notesDropdown
            elementId="input-modal-note"
            [items]="user.noteOptions"
            [multiple]="true"
            clearAllText="Clear"
            name="note"
            [addTag]="true"
            [(ngModel)]="party.note"
            placeholder="Select notes"
            [clearable]="true"
            [plainValues]="true"
            [inlineClearButton]="false"
          ></frontend-dropdown>
        </ng-container>
        <ng-template #plainNoteInput>
          <label for="input-modal-note" class="control-label">Notes</label>
          <input type="text"
                 name="note"
                 [(ngModel)]="party.note"
                 id="input-modal-note"
                 class="form-control"
                 trTrimSpaces
          />
        </ng-template>
      </div>
      <!-- services -->
      <div *ngIf="servicesInDropdown?.length"
           class="col-xs-12 col-sm-6 form-group">
        <frontend-dropdown-clear [dropdown]="servicesDropdown">
          <label class="control-label">
            {{user.serviceSettings?.label || 'service'}}
            <span *ngIf="shortenedDurationState?.hasShortenedDuration" class="text-warning ml-1">⚠️</span>
          </label>
        </frontend-dropdown-clear>
        <frontend-dropdown
          #servicesDropdown
          elementId="input-modal-service"
          [items]="servicesInDropdown"
          [multiple]="true"
          bindLabel="name"
          bindValue="_id"
          clearAllText="Clear"
          name="services"
          [(ngModel)]="party.services"
          (ngModelChange)="selectServices()"
          [clearable]="true"
          [inlineClearButton]="false"
          [customOptionHtml]="getServiceOptionName"
        ></frontend-dropdown>
      </div>
      <!-- duration -->
      <div *ngIf="servicesInDropdown?.length && party?.services?.length && party?.duration"
           class="col-xs-12 col-sm-6 form-group">
        <label for="input-modal-services-duration" class="control-label">{{user.serviceSettings?.label || 'service'}} duration</label>
        <div data-toggle="buttons" class="with-five-buttons d-flex justify-content-between">
          <input class="form-control"
                 type="number"
                 name="duration"
                 #partyDurationInMinutes
                 [(ngModel)]="party.durationInMinutes"
                 id="input-modal-services-duration"
                 pattern="[-\d]*"
                 min="0"
                 required
                 [ngClass]="{'is-invalid': partyDurationInMinutes.touched && partyDurationInMinutes.invalid }"
                 (change)="changeDuration()"/>
          <button type="button" class="btn btn-info" (click)="changeQuoted(5, 'durationInMinutes', 'duration')">+5</button>
          <button type="button" class="btn btn-info" (click)="changeQuoted(-5, 'durationInMinutes', 'duration')">-5</button>
        </div>
      </div>
      <!-- resources -->
      <div *ngIf="resourcesInDropdown?.length"
           class="col-xs-12 col-sm-6 form-group">
        <frontend-dropdown-clear [dropdown]="resourcesDropdown">
          <label class="control-label">{{user.resourceSettings?.label || 'resource'}}</label>
        </frontend-dropdown-clear>
        <frontend-dropdown
          #resourcesDropdown
          elementId="input-modal-resource"
          [items]="resourcesInDropdown"
          [multiple]="true"
          clearAllText="Clear"
          name="resources"
          [(ngModel)]="party.resources"
          (ngModelChange)="this.selectResources()"
          (itemsClear)="onResourceInputClear()"
          (itemClear)="clearSelectedResource($event)"
          [customName]="getItemName"
          [customOptionHtml]="getItemOptionName"
          [clearable]="true"
          [inlineClearButton]="false"
          [markFirstSuggested]="user?.resourceSettings.resourceSuggestion === resourceSuggestionOption.suggestion"
        ></frontend-dropdown>
      </div>
    </div>

    <ng-container *ngIf="availableOnBusinessPlan">
      <tablesready-party-custom-fields
        id="customFields"
        name="customFields"
        [config]="user.partyFields"
        [(ngModel)]="party.customFields"
        [country]="user.country"
      ></tablesready-party-custom-fields>
    </ng-container>

    <div *ngIf="isAvailableTime && !showOverlappingAlert"
         class="alert alert-warning d-flex justify-content-between"
         role="alert">
      Sorry, we don't have an available {{user.resourceSettings?.label || 'resource'}} at this time.
      <label class="form-check-label pl-0 d-flex">
        <strong>Override?</strong>
        <input type="checkbox"
               class="ml-2"
               name="overrideNoResources"
               [(ngModel)]="overrideNoResources"
               (change)="overrideResources()">
      </label>
    </div>
    <div *ngIf="showBusinessHoursWarning(addEditForm)"
         class="alert alert-warning" role="alert">
      {{ getOutOfBusinessHoursMessage() }}
      <label class="form-check-label pl-0 d-flex">
        <strong>Override?</strong>
        <input type="checkbox"
               class="ml-2"
               name="overrideNoResources"
               [(ngModel)]="overrideIsWorkTime"
               (change)="checkWorkTime()">
      </label>
    </div>
    <div *ngIf="isReservation && blockedTime?.blocked && !overrideBlockedTime"
         class="alert alert-warning d-flex justify-content-between"
         role="alert">
      This time is blocked for new {{ displayOptionsReservationsLabelPlural }}.
      <label class="form-check-label pl-0 d-flex">
        <strong>Override?</strong>
        <input type="checkbox"
               class="ml-2"
               name="overrideBlockedTime"
               [(ngModel)]="overrideBlockedTime">
      </label>
    </div>
    <div *ngIf="showNoServicesWarning(addEditForm)"
         class="alert alert-warning"
         role="alert">
      Sorry, no services available at this time.
    </div>
    <div *ngIf="resourceSizeAlert"
         class="alert alert-warning"
         role="alert">
      {{ resourceSizeAlert }}
    </div>
    <div *ngIf="showOverlappingAlert && !overrideNoResources" class="alert alert-warning" role="alert">
      Sorry, this {{user.displayOptions?.labels?.reservation || 'reservation'}} overlaps with another, override?
      <input type="checkbox"
             class="mt-1 ml-2"
             name="overrideNoResources"
             [(ngModel)]="overrideNoResources"
             (change)="overrideResources()">
    </div>
    <!-- Shortened duration warning -->
    <tablesready-shortened-duration-warning
      *ngIf="!isSubmitting"
      [state]="shortenedDurationState"
      [(confirmed)]="shortenedDurationConfirmed"
    ></tablesready-shortened-duration-warning>
  </form>
</div>

<div modalFooter class="modal-footer">
  <button *ngIf="isReservation && party?.checkin_time"
          type="button"
          class="btn btn-success mr-auto"
          angularticsCategory="waitlist"
          angulartics2On="click"
          angularticsAction="undo reservation check-in"
          (click)="undoCheckIn()"
          [disabled]="isSubmitting">Undo Check-In
  </button>
  <button *ngIf="party?.checkin_time && party?.seated_time"
          type="button"
          class="btn btn-success mr-auto"
          (click)="undoServed()"
          angularticsCategory="parties"
          angulartics2On="click"
          angularticsAction="undo party serve"
          [disabled]="isSubmitting"
  >Undo Served</button>
  <button type="submit"
          class="btn btn-info"
          (click)="ok()"
          angularticsCategory="waitlist"
          angulartics2On="click"
          id="confirm-add-edit-party-button"
          [disabled]="isSubmitDisabled(addEditForm)"
          angularticsAction="{{angularticsActionType}}">{{ confirmBtnText }}
  </button>
  <button type="button" class="btn btn-danger" (click)="cancel()">Cancel
  </button>
</div>

<ng-template #confirmModalContent let-confirmModal>
  <div class="modal-header">
    <h3 class="modal-title" id="modal-basic-title">
      There is already a {{user?.displayOptions?.labels?.customer || 'customer'}} on your waitlist with this phone number. Are you sure you want to proceed?
    </h3>
    <tr-icon [icon]="icon.cancel" classes="ml-auto py-1 px-2" (click)="confirmModal.close('Cancel click')"></tr-icon>
  </div>
  <div class="modal-footer">
    <button type="submit" class="btn btn-success" (click)="confirmModal.close('Confirm click')">Confirm</button>
    <button type="button" class="btn btn-danger" (click)="confirmModal.close('Cancel click')" >Cancel</button>
  </div>
</ng-template>
